module.exports = __webpack_public_path__ + "static/types-d6a150bfd55f9a28bd38d4138d777726.png";